import request from "@/utils/request";

// 平台活动管理-活动列表
export function activityList(params) {
    return request({
        url: `/marketing/platform/activity/ops/get/activity/page`,
        method: "get",
        params,
    });
}

// 平台活动管理-新建平台活动
export function activityAdd(data) {
    return request({
        url: `/marketing/platform/activity/ops/add/plm/activity`,
        method: "post",
        data,
    });
}

// 平台活动管理-编辑、更新活动
export function activityUpdate(data) {
    return request({
        url: `/marketing/platform/activity/ops/update/plm/activity`,
        method: "PUT",
        data,
    });
}

// 平台活动管理-查看平台活动详情
export function activityDetails(id) {
    return request({
        url: `/marketing/platform/activity/ops/get/activity/details?id=${id}`,
        method: "get",
    });
}

//平台活动管理-停止活动
export function activityStartOrStop(id) {
    return request({
        url: `/marketing/platform/activity/ops/stop/plm/activity/${id}`,
        method: "PUT",
    });
}

//平台活动管理-删除活动
export function activityDelete(id) {
    return request({
        url: `/marketing/platform/activity/ops/delete/activity?id=${id}`,
        method: "delete",
    });
}

//平台活动管理-查询活动商品列表
export function activityGoodsInfo(params) {
    return request({
        url: `/marketing/platform/activity/ops/get/activity/goods/info`,
        method: "get",
        params
    });
}

//根据店铺名或手机号搜索店铺
export function queryShopListByKeyword(params) {
    return request({
        url: `/shop/shop/queryShopListByKeyword`,
        method: "get",
        params,
    });
}

// 根据shopList查询sku列表 (活动规则创建，选择商品)

export function queryPlatformActivitySkuPage(data) {
    return request({
        url: `/product/stock/sku/querySkuPageByShopList`,
        method: "post",
        data: data,
    });
}


//平台活动基库商品查询

export function goodsbasePlmActivityGoodsPage(params) {
    return request({
        url: `/product/goodsbase/plmActivity/goodsPage`,
        method: "get",
        params,
    });
}

export function queryRuleSkuPageByShopListNew(data) {
    return request({
        url: `/product/stock/ops/queryRuleSkuPageByShopList`,
        method: "post",
        data: data,
    });
}

// 新增活动规则
export function activityRulesAdd(data) {
    return request({
        url: `/marketing/platform/activity/ops/addPlmActivityRule`,
        method: "post",
        data,
    });
}

//查询活动规则列表
export function queryActivityRuleList(data) {
    return request({
        url: `/marketing/platform/activity/ops/get/activity/rules/info`,
        method: "get",
        params: data,
    });
}



//修改活动规则
export function activityRulesUpdate(data) {
    return request({
        url: `/marketing/platform/activity/rules/update`,
        method: "post",
        data: data,
    });
}


//活动规则详情
export function activityRulesInfo(id) {
    return request({
        url: `/marketing/platform/activity/rules/info/${id}`,
        method: "get",
    });
}

//删除活动规则
export function activityRulesDelete(id) {
    return request({
        url: `/marketing/platform/activity/ops/delete/activity/rules/${id}`,
        method: "delete",
    });
}

//删除活动商品
export function activityGoodsDelete(id) {
    return request({
        url: `/marketing//platform/activity/ops/delete/activity/goods/${id}`,
        method: "delete",
    });
}


//批量移除参与活动的商品
export function deleteActivityGoodsList(data) {
    return request({
        url: `/marketing/platform/activity/ops/delete/activity/goods/list`,
        method: "post",
        data,
    });
}

// 查询所有活动商品列表
export function getAllActivityGoodsInfo(params) {
    return request({
        url: `/marketing/platform/activity/ops/get/all/activity/goods/info`,
        method: "get", 
        params
    });
}





// 活动规则详情
export function queryActivityRuleInfo(id) {
    return request({
        url: `/marketing/platform/activity/rules/info/${id}`,
        method: "get", 
    });
}


//平台活动申请审核列表查询
export function queryActivityApplyList(data) {
    return request({
        url: `/marketing/platform/activity/list/get/apply/activity/page`,
        method: "get",
        params: data,
    });
}


// 查询申请详情
export function queryActivityApplyInfo(data) {
    return request({
        url: `/marketing/platform/activity/list/get/apply/info`,
        method: "get",
        params: data,
    });
}

export function checkActivityApply(data) {
    return request({
        url: `/marketing/platform/activity/apply/checkActivityApply`,
        method: "post",
        data: data,
    });
}